export const GETTING_DEVICES = "GETTING_DEVICES";
export const LIST_DEVICES = "LIST_DEVICES";
export const ERROR = "ERROR";
export const GETTING_GROUPS = "GETTING_GROUPS";
export const LIST_GROUPS = "LIST_GROUPS";
export const GET_POSITIONS = "GET_POSITIONS";
export const LIST_POSITION = "LIST_POSITION";
export const REPORT_SUMMARY = "REPORT_SUMMARY";
export const GET_REPORTS = "GET_REPORTS";
